<template lang="html">
  <div>
    <b-card>
      <b-row class="panel">
        <img src="/static/img/comingsoon.jpg" height="50%" width="50%">
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
}

$(document).ready(function(e){
	genRowspan("first");
});

function genRowspan(className){
	$("." + className).each(function() {
		var rows = $("." + className + ":contains('" + $(this).text() + "')");
		if (rows.length > 1) {
			rows.eq(0).attr("rowspan", rows.length);
			rows.not(":eq(0)").remove();
		}
	});
}
</script>

<style lang="css" scoped>
.panel {
  min-width:1200px;
  height:730px;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/TempPage.vue